
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";

interface RegisterActionsProps {
  isLoading: boolean;
}

const RegisterActions = ({ isLoading }: RegisterActionsProps) => {
  return (
    <div>
      <Button
        type="submit"
        className="group relative flex w-full justify-center rounded-md border border-transparent bg-socialsync-600 px-4 py-2 text-sm font-medium text-white hover:bg-socialsync-700 focus:outline-none focus:ring-2 focus:ring-socialsync-500 focus:ring-offset-2"
        disabled={isLoading}
      >
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <UserPlus className="h-5 w-5 text-socialsync-500 group-hover:text-socialsync-400" />
        </span>
        {isLoading ? "Création en cours..." : "Créer un compte entreprise"}
      </Button>
      <p className="mt-2 text-xs text-center text-blue-600">
        Essai gratuit de 15 jours ! Aucune carte de crédit requise.
      </p>
    </div>
  );
};

export default RegisterActions;
